<template>
  <div class="numbertab">
    <div class="drawer-card">
      <van-row style="margin-top: 3px">
        <van-col span="8">
          <van-button
            @click="s0Click"
            v-model="s0"
            :color="a ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            0 {{ odds[16] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s1Click"
            v-model="s1"
            :color="b ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            1 {{ odds[17] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s2Click"
            v-model="s2"
            :color="c ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            2 {{ odds[18] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="8">
          <van-button
            @click="s3Click"
            v-model="s3"
            :color="d ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            3 {{ odds[19] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s4Click"
            v-model="s4"
            :color="e ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            4 {{ odds[20] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s5Click"
            v-model="s5"
            :color="f ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            5 {{ odds[21] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="8">
          <van-button
            @click="s6Click"
            v-model="s6"
            :color="g ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            6 {{ odds[22] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s7Click"
            v-model="s7"
            :color="h ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            7 {{ odds[23] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s8Click"
            v-model="s8"
            :color="i ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            8 {{ odds[24] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="8">
          <van-button
            @click="s9Click"
            v-model="s9"
            :color="j ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            9 {{ odds[25] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s10Click"
            v-model="s10"
            :color="k ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            10 {{ odds[26] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s11Click"
            v-model="s11"
            :color="l ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            11 {{ odds[27] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="8">
          <van-button
            @click="s12Click"
            v-model="s12"
            :color="m ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            12 {{ odds[28] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s13Click"
            v-model="s13"
            :color="n ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            13 {{ odds[29] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s14Click"
            v-model="s14"
            :color="o ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            14 {{ odds[30] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="8">
          <van-button
            @click="s15Click"
            v-model="s15"
            :color="p ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            15 {{ odds[31] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s16Click"
            v-model="s16"
            :color="q ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            16 {{ odds[32] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s17Click"
            v-model="s17"
            :color="r ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            17 {{ odds[33] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="8">
          <van-button
            @click="s18Click"
            v-model="s18"
            :color="s ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            18 {{ odds[34] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s19Click"
            v-model="s19"
            :color="t ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            19 {{ odds[35] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s20Click"
            v-model="s20"
            :color="u ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            20 {{ odds[36] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="8">
          <van-button
            @click="s21Click"
            v-model="s21"
            :color="v ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            21 {{ odds[37] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s22Click"
            v-model="s22"
            :color="w ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            22 {{ odds[38] }}
          </van-button>
        </van-col>
        <van-col span="8">
          <van-button
            @click="s23Click"
            v-model="s23"
            :color="x ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            23 {{ odds[39] }}
          </van-button>
        </van-col>
      </van-row>
      <van-row style="margin-top: 3px">
        <van-col span="6">
          <van-button
            @click="s24Click"
            v-model="s24"
            :color="y ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            24 {{ odds[40] }}
          </van-button>
        </van-col>
        <van-col span="6">
          <van-button
            @click="s25Click"
            v-model="s25"
            :color="z ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            25 {{ odds[41] }}
          </van-button>
        </van-col>
        <van-col span="6">
          <van-button
            @click="s26Click"
            v-model="s26"
            :color="aa ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            26 {{ odds[42] }}
          </van-button>
        </van-col>
        <van-col span="6">
          <van-button
            @click="s27Click"
            v-model="s27"
            :color="bb ? '#1C1C36' : ''"
            class="button-style"
            size="large"
            round
            type=""
          >
            27 {{ odds[43] }}
          </van-button>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "numbertab",
  props: ["target", "odds", "combination", "clear"],
  data() {
    return {
      s0: "",
      a: false,
      s1: "",
      b: false,
      s2: "",
      c: false,
      s3: "",
      d: false,
      s4: "",
      e: false,
      s5: "",
      f: false,
      s6: "",
      g: false,
      s7: "",
      h: false,
      s8: "",
      i: false,
      s9: "",
      j: false,
      s10: "",
      k: false,
      s11: "",
      l: false,
      s12: "",
      m: false,
      s13: "",
      n: false,
      s14: "",
      o: false,
      s15: "",
      p: false,
      s16: "",
      q: false,
      s17: "",
      r: false,
      s18: "",
      s: false,
      s19: "",
      t: false,
      s20: "",
      u: false,
      s21: "",
      v: false,
      s22: "",
      w: false,
      s23: "",
      x: false,
      s24: "",
      y: false,
      s25: "",
      z: false,
      s26: "",
      aa: false,
      s27: "",
      bb: false,
      value: [],
      distVal: {
        val: "",
        total: "",
      },
    };
  },
  watch: {
    combination(newValue, oldValue) {
      if (newValue) {
        this.value.forEach((v, i) => {
          this.distVal.val += v + ";";
        });
        this.distVal.total = this.value.length;
        this.$emit("num", this.distVal);
      }
    },
    clear(newValue, oldValue) {
      if (newValue) {
        this.initOrigin();
      }
    },
  },
  methods: {
    s0Click() {
      this.a = !this.a;
      if (this.a) {
        this.s0 = this.target[16];
        this.value.push(this.s0);
      } else {
        this.value.map((val, i) => {
          if (val === this.s0) {
            this.value.splice(i, 1);
          }
        });
        this.s0 = "";
      }
    },
    s1Click() {
      this.b = !this.b;
      if (this.b) {
        this.s1 = this.target[17];
        this.value.push(this.s1);
      } else {
        this.value.map((val, i) => {
          if (val === this.s1) {
            this.value.splice(i, 1);
          }
        });
        this.s1 = "";
      }
    },
    s2Click() {
      this.c = !this.c;
      if (this.c) {
        this.s2 = this.target[18];
        this.value.push(this.s2);
      } else {
        this.value.map((val, i) => {
          if (val === this.s2) {
            this.value.splice(i, 1);
          }
        });
        this.s2 = "";
      }
    },
    s3Click() {
      this.d = !this.d;
      if (this.d) {
        this.s3 = this.target[19];
        this.value.push(this.s3);
      } else {
        this.value.map((val, i) => {
          if (val === this.s3) {
            this.value.splice(i, 1);
          }
        });
        this.s3 = "";
      }
    },
    s4Click() {
      this.e = !this.e;
      if (this.e) {
        this.s4 = this.target[20];
        this.value.push(this.s4);
      } else {
        this.value.map((val, i) => {
          if (val === this.s4) {
            this.value.splice(i, 1);
          }
        });
        this.s4 = "";
      }
    },
    s5Click() {
      this.f = !this.f;
      if (this.f) {
        this.s5 = this.target[21];
        this.value.push(this.s5);
      } else {
        this.value.map((val, i) => {
          if (val === this.s5) {
            this.value.splice(i, 1);
          }
        });
        this.s5 = "";
      }
    },
    s6Click() {
      this.g = !this.g;
      if (this.g) {
        this.s6 = this.target[22];
        this.value.push(this.s6);
      } else {
        this.value.map((val, i) => {
          if (val === this.s6) {
            this.value.splice(i, 1);
          }
        });
        this.s6 = "";
      }
    },
    s7Click() {
      this.h = !this.h;
      if (this.h) {
        this.s7 = this.target[23];
        this.value.push(this.s7);
      } else {
        this.value.map((val, i) => {
          if (val === this.s7) {
            this.value.splice(i, 1);
          }
        });
        this.s7 = "";
      }
    },
    s8Click() {
      this.i = !this.i;
      if (this.i) {
        this.s8 = this.target[24];
        this.value.push(this.s8);
      } else {
        this.value.map((val, i) => {
          if (val === this.s8) {
            this.value.splice(i, 1);
          }
        });
        this.s8 = "";
      }
    },
    s9Click() {
      this.j = !this.j;
      if (this.j) {
        this.s9 = this.target[25];
        this.value.push(this.s9);
      } else {
        this.value.map((val, i) => {
          if (val === this.s9) {
            this.value.splice(i, 1);
          }
        });
        this.s9 = "";
      }
    },
    s10Click() {
      this.k = !this.k;
      if (this.k) {
        this.s10 = this.target[26];
        this.value.push(this.s10);
      } else {
        this.value.map((val, i) => {
          if (val === this.s10) {
            this.value.splice(i, 1);
          }
        });
        this.s10 = "";
      }
    },
    s11Click() {
      this.l = !this.l;
      if (this.l) {
        this.s11 = this.target[27];
        this.value.push(this.s11);
      } else {
        this.value.map((val, i) => {
          if (val === this.s11) {
            this.value.splice(i, 1);
          }
        });
        this.s11 = "";
      }
    },
    s12Click() {
      this.m = !this.m;
      if (this.m) {
        this.s12 = this.target[28];
        this.value.push(this.s12);
      } else {
        this.value.map((val, i) => {
          if (val === this.s12) {
            this.value.splice(i, 1);
          }
        });
        this.s12 = "";
      }
    },
    s13Click() {
      this.n = !this.n;
      if (this.n) {
        this.s13 = this.target[29];
        this.value.push(this.s13);
      } else {
        this.value.map((val, i) => {
          if (val === this.s13) {
            this.value.splice(i, 1);
          }
        });
        this.s13 = "";
      }
    },
    s14Click() {
      this.o = !this.o;
      if (this.o) {
        this.s14 = this.target[30];
        this.value.push(this.s14);
      } else {
        this.value.map((val, i) => {
          if (val === this.s14) {
            this.value.splice(i, 1);
          }
        });
        this.s14 = "";
      }
    },
    s15Click() {
      this.p = !this.p;
      if (this.p) {
        this.s15 = this.target[31];
        this.value.push(this.s15);
      } else {
        this.value.map((val, i) => {
          if (val === this.s15) {
            this.value.splice(i, 1);
          }
        });
        this.s15 = "";
      }
    },
    s16Click() {
      this.q = !this.q;
      if (this.q) {
        this.s16 = this.target[32];
        this.value.push(this.s16);
      } else {
        this.value.map((val, i) => {
          if (val === this.s16) {
            this.value.splice(i, 1);
          }
        });
        this.s16 = "";
      }
    },
    s17Click() {
      this.r = !this.r;
      if (this.r) {
        this.s17 = this.target[33];
        this.value.push(this.s17);
      } else {
        this.value.map((val, i) => {
          if (val === this.s17) {
            this.value.splice(i, 1);
          }
        });
        this.s17 = "";
      }
    },
    s18Click() {
      this.s = !this.s;
      if (this.s) {
        this.s18 = this.target[34];
        this.value.push(this.s18);
      } else {
        this.value.map((val, i) => {
          if (val === this.s18) {
            this.value.splice(i, 1);
          }
        });
        this.s18 = "";
      }
    },
    s19Click() {
      this.t = !this.t;
      if (this.t) {
        this.s19 = this.target[35];
        this.value.push(this.s19);
      } else {
        this.value.map((val, i) => {
          if (val === this.s19) {
            this.value.splice(i, 1);
          }
        });
        this.s19 = "";
      }
    },
    s20Click() {
      this.u = !this.u;
      if (this.u) {
        this.s20 = this.target[36];
        this.value.push(this.s20);
      } else {
        this.value.map((val, i) => {
          if (val === this.s20) {
            this.value.splice(i, 1);
          }
        });
        this.s20 = "";
      }
    },
    s21Click() {
      this.v = !this.v;
      if (this.v) {
        this.s21 = this.target[37];
        this.value.push(this.s21);
      } else {
        this.value.map((val, i) => {
          if (val === this.s21) {
            this.value.splice(i, 1);
          }
        });
        this.s21 = "";
      }
    },
    s22Click() {
      this.w = !this.w;
      if (this.w) {
        this.s22 = this.target[38];
        this.value.push(this.s22);
      } else {
        this.value.map((val, i) => {
          if (val === this.s22) {
            this.value.splice(i, 1);
          }
        });
        this.s22 = "";
      }
    },
    s23Click() {
      this.x = !this.x;
      if (this.x) {
        this.s23 = this.target[39];
        this.value.push(this.s23);
      } else {
        this.value.map((val, i) => {
          if (val === this.s23) {
            this.value.splice(i, 1);
          }
        });
        this.s23 = "";
      }
    },
    s24Click() {
      this.y = !this.y;
      if (this.y) {
        this.s24 = this.target[40];
        this.value.push(this.s24);
      } else {
        this.value.map((val, i) => {
          if (val === this.s24) {
            this.value.splice(i, 1);
          }
        });
        this.s24 = "";
      }
    },
    s25Click() {
      this.z = !this.z;
      if (this.z) {
        this.s25 = this.target[41];
        this.value.push(this.s25);
      } else {
        this.value.map((val, i) => {
          if (val === this.s25) {
            this.value.splice(i, 1);
          }
        });
        this.s25 = "";
      }
    },
    s26Click() {
      this.aa = !this.aa;
      if (this.aa) {
        this.s26 = this.target[42];
        this.value.push(this.s26);
      } else {
        this.value.map((val, i) => {
          if (val === this.s26) {
            this.value.splice(i, 1);
          }
        });
        this.s26 = "";
      }
    },
    s27Click() {
      this.bb = !this.bb;
      if (this.bb) {
        this.s27 = this.target[43];
        this.value.push(this.s27);
      } else {
        this.value.map((val, i) => {
          if (val === this.s27) {
            this.value.splice(i, 1);
          }
        });
        this.s27 = "";
      }
    },
    initOrigin() {
      this.a = false;
      this.b = false;
      this.c = false;
      this.d = false;
      this.e = false;
      this.f = false;
      this.g = false;
      this.h = false;
      this.i = false;
      this.j = false;
      this.k = false;
      this.l = false;
      this.m = false;
      this.n = false;
      this.o = false;
      this.p = false;
      this.q = false;
      this.r = false;
      this.s = false;
      this.t = false;
      this.u = false;
      this.v = false;
      this.w = false;
      this.x = false;
      this.y = false;
      this.z = false;
      this.aa = false;
      this.bb = false;
      this.value = [];
      this.distVal = {
        val: "",
        total: 0
      }
    },
  },
};
</script>

<style>
.numbertab {
  height: 360px;
  overflow: auto; /* 可选值：scroll, hidden, visible */
}

.drawer-card {
  padding: 20px;
}

.button-style {
  border: 1px solid;
  height: 40px;
}
</style>
